export const API_PATH_ApiAppVersionGet = '/services/app/version';
